"use client";

import { lazy } from "react";
import type { ToolUIRegistry } from "../../tool-renderer";

/**
 * Read-only display cards for the Concur attendee/receipt WRITE tools. Each
 * card shows what was requested plus the outcome; none offers an action.
 */
export const concurAttendeeWriteToolRegistry = {
  concurAddAttendeesToExpense: {
    kind: "standalone",
    category: "create",
    view: lazy(() =>
      import("./attendee-write-views").then(
        ({ ConcurAddAttendeesToolView }) => ({
          default: ConcurAddAttendeesToolView,
        })
      )
    ),
  },
  concurCopyAttendees: {
    kind: "standalone",
    category: "create",
    view: lazy(() =>
      import("./attendee-write-views").then(
        ({ ConcurCopyAttendeesToolView }) => ({
          default: ConcurCopyAttendeesToolView,
        })
      )
    ),
  },
  concurUploadReceipt: {
    kind: "standalone",
    category: "create",
    view: lazy(() =>
      import("./attendee-write-views").then(
        ({ ConcurUploadReceiptToolView }) => ({
          default: ConcurUploadReceiptToolView,
        })
      )
    ),
  },
} satisfies ToolUIRegistry;
